import { createTheme } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const theme = createTheme({
  palette: {
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  overrides: {
    MuiTable: {
      root: {
        borderCollapse: 'unset',
      },
    },
    MuiTableCell: {
      paddingCheckbox: {
        display: 'none',
      },
    },
    MuiDrawer: {
      root: {
        borderRight: '1px solid lightgray',
        minHeight: 600,
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: '#fafafa',
      },
    },
    MuiPaper: {
      elevation2: {
        boxShadow: 'none',
      },
    },
    MuiInput: {
      multiline: {
        '& .MuiInput-inputMultiline': {
          boxShadow: '0px -1px 1px 0px rgba(0,0,0,0.2)',
          padding: 10,
          borderRadius: 2,
        },
      },
    },
    MuiInputLabel: {
      formControl: {
        top: 2,
        left: 5,
      },
    },
    MuiFormControl: {
      root: {
        '& .MuiTypography-h5': {
          color: 'rgba(0, 0, 0, 0.54)',
          padding: 0,
          fontSize: '1rem',
          fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif',
          fontWeight: 400,
          lineHeight: 1,
        },
        '& p.MuiTypography-h5': {
          margin: '5px 0',
          fontSize: '0.75rem',
        },
      },
    },
    MuiBreadcrumbs: {
      root: {
        '& a': {
          textDecoration: 'none',
        },
      },
    },
  },
});